const FORCE_DELETE_STATUS = new Set([
  '执行中',
  '执行成功',
  '执行失败',
  '部分成功',
  '已完成',
]);

const STATUS_PRIORITY = ['执行中', '等待执行', '执行失败', '部分成功', '执行成功'];
const FEED_PRIORITY = {
  执行中: 0,
  等待执行: 1,
  执行失败: 2,
  部分成功: 3,
  执行成功: 4,
  已完成: 5,
};

const normalizeText = (value) => String(value || '').toLowerCase();

export const shouldForceDeleteTask = (status) => FORCE_DELETE_STATUS.has(status);

export const buildTaskStatusStats = (tasks) => {
  const counts = (tasks || []).reduce((acc, task) => {
    const status = task?.status;
    if (status) {
      acc[status] = (acc[status] || 0) + 1;
    }
    return acc;
  }, {});

  return STATUS_PRIORITY.map((status) => ({
    status,
    count: counts[status] || 0,
  }));
};

export const buildTaskFeed = (tasks, limit = 4) => {
  return [...(tasks || [])]
    .sort((left, right) => {
      const leftPriority = FEED_PRIORITY[left?.status] ?? 99;
      const rightPriority = FEED_PRIORITY[right?.status] ?? 99;
      if (leftPriority !== rightPriority) {
        return leftPriority - rightPriority;
      }

      const leftTime = left?.execution_time || left?.date_str || '';
      const rightTime = right?.execution_time || right?.date_str || '';
      return rightTime.localeCompare(leftTime);
    })
    .slice(0, limit);
};

export const filterTasks = (tasks, filters) => {
  const keyword = normalizeText(filters?.keyword).trim();
  const status = filters?.status || 'all';
  const dateRange = Array.isArray(filters?.dateRange) ? filters.dateRange : [];
  const [startDate, endDate] = dateRange;

  return (tasks || []).filter((task) => {
    const taskDate = task?.date_str || '';
    const taskStatus = task?.status || '';

    if (status !== 'all' && taskStatus !== status) {
      return false;
    }

    if (startDate && taskDate < startDate) {
      return false;
    }

    if (endDate && taskDate > endDate) {
      return false;
    }

    if (!keyword) {
      return true;
    }

    const searchable = [
      task?.id,
      task?.name,
      task?.phone,
      task?.date_str,
      Array.isArray(task?.time_slots) ? task.time_slots.join(',') : task?.time_slots,
      Array.isArray(task?.resource_ids) ? task.resource_ids.join(',') : task?.resource_ids,
      task?.status,
      task?.result,
    ]
      .map(normalizeText)
      .join(' ');

    return searchable.includes(keyword);
  });
};
